var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcon = function SvgIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -285.949,
    y1: -22.057,
    x2: -285.949,
    y2: -23.077,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#eff6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#c6dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#acd0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2cbff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -204.794,
    y1: 53.905,
    x2: -203.794,
    y2: 53.902,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc7200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fca22e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdd661"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 343.504,
    y1: 53.484,
    x2: 342.507,
    y2: 53.483,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdd661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fca22e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc7200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.094,
    y1: 0.285,
    x2: 1.098,
    y2: 0.856,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fbfdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#eff6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#dbebff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#bfdbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2cbff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.18,
    y1: 0.399,
    x2: 0.836,
    y2: 1.201,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -88.675,
    y1: 313.52,
    x2: -87.687,
    y2: 313.673,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcc715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fcc019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fda729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fd9732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd9235"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -324.731,
    y1: -5.903,
    x2: -324.022,
    y2: -5.199,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2559cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#25c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#1b4ac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f38c1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -338.534,
    y1: -6.735,
    x2: -338.027,
    y2: -6.177,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f38c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#143fc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2052ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2559cd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -688.516,
    y1: 55.327,
    x2: -685.347,
    y2: 55.848,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_896",
    "data-name": "Group 896",
    transform: "translate(-662 -350)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_341",
    "data-name": "Ellipse 341",
    cx: 58,
    cy: 58,
    r: 58,
    transform: "translate(662 350)",
    fill: "#dbdfff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_342",
    "data-name": "Ellipse 342",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(688 377)",
    fill: "#2c40ce"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_344",
    "data-name": "Ellipse 344",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(709 444)",
    fill: "#2c40ce"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_343",
    "data-name": "Ellipse 343",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(749 411)",
    fill: "#fc9723"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Product_tour",
    "data-name": "Product tour",
    transform: "translate(712.121 328.04) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "translate(45.02 17.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2849",
    "data-name": "Path 2849",
    d: "M78.126,133.05A6.126,6.126,0,0,0,72,139.156c0,8.767,6.126,14.5,6.126,26.363,0-11.868,6.126-17.611,6.126-26.363A6.126,6.126,0,0,0,78.126,133.05Z",
    transform: "translate(-61.671 -88.843)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2850",
    "data-name": "Path 2850",
    d: "M81.409,133.05a4.089,4.089,0,0,0-4.089,4.089c0,5.869,4.089,9.705,4.089,17.649,0-7.944,4.085-11.78,4.085-17.649a4.089,4.089,0,0,0-4.085-4.089Z",
    transform: "translate(-64.954 -88.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2851",
    "data-name": "Path 2851",
    d: "M0,0H9.832V1.558a.716.716,0,0,1-.716.716H.716A.716.716,0,0,1,0,1.558Z",
    transform: "translate(11.453 43.472) rotate(0.29)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2852",
    "data-name": "Path 2852",
    d: "M105.786,94.69l5.406,7.607a3.828,3.828,0,0,1,.6,3.147l-2.554,10.364a.452.452,0,0,1-.766.222l-8.174-7.439Z",
    transform: "translate(-79.136 -65.169)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2853",
    "data-name": "Path 2853",
    d: "M51.2,94.51l-5.456,7.569a3.859,3.859,0,0,0-.624,3.143L47.608,115.6a.456.456,0,0,0,.766.23l8.239-7.408Z",
    transform: "translate(-45.019 -65.058)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2854",
    "data-name": "Path 2854",
    d: "M71.247,17.58c-9.284,7.569-14.445,31.5-6.968,42.879a1.171,1.171,0,0,0,.965.563l11.6.061a1.172,1.172,0,0,0,.972-.555C85.4,49.234,80.47,25.245,71.247,17.58Z",
    transform: "translate(-54.697 -17.58)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2855",
    "data-name": "Path 2855",
    d: "M74.776,17.58c-3.358,2.734-6.168,7.607-8.04,13.25-2.982-.142,15.953.069,15.953.069C80.867,25.245,78.1,20.344,74.776,17.58Z",
    transform: "translate(-58.225 -17.58)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_340",
    "data-name": "Ellipse 340",
    cx: 5.348,
    cy: 5.348,
    r: 5.348,
    transform: "translate(8.878 22.918) rotate(-43.92)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2856",
    "data-name": "Path 2856",
    d: "M85.253,70.182a4.33,4.33,0,1,1-1.705-2.845A4.334,4.334,0,0,1,85.253,70.182Z",
    transform: "translate(-64.529 -47.762)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2857",
    "data-name": "Path 2857",
    d: "M85.82,72.091a4.322,4.322,0,0,0-1.313-2.511,1.545,1.545,0,0,0,.027.352,3.94,3.94,0,0,1,.023,1.6,1.627,1.627,0,0,1-.988,1.045c-.67.241-1.451.023-2.1.314-.789.36-1.126,1.359-1.914,1.734a2.079,2.079,0,0,1-1.2.13,1.726,1.726,0,0,1-.8-.31,4.33,4.33,0,0,0,8.262-2.351Z",
    transform: "translate(-65.096 -49.672)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891",
    transform: "translate(13.042 19.452)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2858",
    "data-name": "Path 2858",
    d: "M87.328,68.39h-.279a.356.356,0,0,0-.245.126.383.383,0,0,0-.084.264.356.356,0,0,0,.356.329h.034a2.151,2.151,0,0,1,.222,0,.348.348,0,0,0,.26-.1.356.356,0,0,0,.107-.256.383.383,0,0,0-.371-.36ZM87.079,69.006Z",
    transform: "translate(-83.796 -68.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2859",
    "data-name": "Path 2859",
    d: "M81.4,69.029a.383.383,0,0,0-.276,0,3.626,3.626,0,0,0-2.018,2.037.36.36,0,0,0,.207.467.3.3,0,0,0,.126.027.383.383,0,0,0,.341-.23A2.864,2.864,0,0,1,81.4,69.7a.348.348,0,0,0,.2-.191.376.376,0,0,0-.191-.479Z",
    transform: "translate(-79.086 -68.768)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2860",
    "data-name": "Path 2860",
    d: "M67.46,61.9c.268.861.559,1.715.884,2.565h5.092l-.279-.413c-.218-.383-.425-.766-.628-1.149-.406-.766-.766-1.589-1.129-2.4a39.069,39.069,0,0,1-1.734-5.092A40.758,40.758,0,0,1,68.3,44.6a41.583,41.583,0,0,1,.383-5.505l.088-.7.119-.685.237-1.371.3-1.359.149-.681.18-.674a54.235,54.235,0,0,1,3.955-10.49,54.778,54.778,0,0,0-5.1,10.142l-.257.67-.226.678-.44,1.363-.383,1.382-.2.693-.188.716a44.946,44.946,0,0,0-1.011,5.693,43.973,43.973,0,0,0,.245,11.65A42.741,42.741,0,0,0,67.46,61.9Z",
    transform: "translate(-57.747 -21.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2861",
    "data-name": "Path 2861",
    d: "M84.952,123.433h0a1.531,1.531,0,0,1-1.531-1.5l-.134-10.363a18.546,18.546,0,0,1,.337-3.828l.992-5.126H85.5l.942,5.138a18.82,18.82,0,0,1,.3,3.828l-.245,10.36A1.531,1.531,0,0,1,84.952,123.433Z",
    transform: "translate(-68.634 -70.056)",
    fill: "url(#linear-gradient-9)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon.4c677c18.svg";
export { ForwardRef as ReactComponent };